<mat-card>
    <mat-card-header class="titreFrm">
        <mat-card-title>{{"Gestion des droits d'accès des utilisateurs".toUpperCase()}}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
        <div *ngIf="exist;else attente"></div>
        <ng-template #attente>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-template>
        <div class="displayFlex">
            <mat-card class="example-card carClass">
                <mat-card-content>
                    <div class="displayFlex">
                        <div style="width: 250px;">
                            <form class="example-form" #formMenu="ngForm">
                                <h4>Ajout de menu</h4>
                                    <mat-form-field     appearance="outline" >
                                        <mat-label>Nom menue</mat-label>
                                        <input matInput name="Tiers_TVA" [(ngModel)]="menu.Menu_Code" placeholder="Nom menue" required>
                                    </mat-form-field>
                                
                                <span class="button-row">
                                    <button (click)="ajouterMenu(formMenu)" [disabled]="disabledBtnAjouter" mat-raised-button
                                        class="colorGreen">
                                        <mat-icon>add</mat-icon>
                                        Ajouter</button>
                                </span>
    
                            </form>
                        </div>
                        <div style="width : 450px">
                            <h4>Liste droits d'accès par menu</h4>
                            <mat-form-field     appearance="outline"  style="width: 200px;margin-right: 5px;">
                                <mat-label>Liste droits d'accès menu</mat-label>
                                <mat-select name="liste_Menu" #liste_Menu="ngModel"
                                    [(ngModel)]="droitAccerMenu.Menu_Code" placeholder="Liste droits d'accès menu"
                                    (selectionChange)="onMenuChange($event.value)" required>
                                    <mat-option *ngFor="let menu of listeMenu" [value]="menu.Menu_Code">
                                        {{menu.Menu_Code}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <span style="margin-right: 5px;" class="button-row">
                                <button (click)="modifierMenu()" [disabled]="disabledBtnModifier" mat-raised-button
                                    class="colorGreen"><mat-icon>save</mat-icon>Enregistrer</button>
                            </span>
                            <span class="button-row">
                                <button (click)="supprimerMenu()" [disabled]="disabledBtnSupprimer" mat-raised-button
                                    class="colorRed"><mat-icon>delete</mat-icon>Supprimer</button>
                            </span>
                            <app-avt-listes [showFilter]="false" #listeComponen [multipleSelect]="false"
                                [heightTable]="'400'" [dataSourceBrut]="[]" [displayedColumnsBrut]="columns"></app-avt-listes>
                        </div>
                        <div class="carClass" style="width: 70px;">
                            <button style="margin-top: 150px;" type="button" (click)="addDroit()" mat-raised-button color="primary">
                                <mat-icon>undo</mat-icon>
                            </button>
                            <br>
                            <br>
                            <button type="button" (click)="removeDroit()" mat-raised-button color="primary">
                                <mat-icon>redo</mat-icon>
                            </button>
                        </div>
                        <div>
                            <h4>Liste droits d'accès</h4>
                            <div class="divMatSelectionList" style="width : 350px;margin-top: 65px;">
                                
                                <app-avt-listes [showFilter]="false" #listeAllRightComponen [multipleSelect]="false"  (btnTable)="clickBtnHeat($event)"
                                    [heightTable]="'400'" [dataSourceBrut]="[]" [displayedColumnsBrut]="columnsAllRight"
                                    [listBtn]="[]"></app-avt-listes>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        
           


    </mat-card-content>
</mat-card>